module.exports = __webpack_public_path__ + "img/04.59731aa8.jpg";